// extracted by mini-css-extract-plugin
export default {"root":"IdentityRequiredNotice_root__aiszp","body":"IdentityRequiredNotice_body__RP7j4","link":"IdentityRequiredNotice_link__QvZoP"};